module.exports = __webpack_public_path__ + "img/about1.b014365e.webp";